import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import "./book-animation.scss";

function AnimatedBook({ link }: { link: string }) {
  return (
    <a href={link}>
      <div className="moleskine-wrapper">
        <div className="moleskine-notebook">
          <div className="notebook-cover"></div>
          <div className="notebook-page"></div>
        </div>
      </div>
    </a>
  );
}

function App() {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  return (
    <Box
      padding={{ xs: 4, md: 4 }}
      justifyContent={"center"}
      maxWidth={"100vw"}
      minHeight={"100vh"}
      sx={{ color: "white" }}
      textAlign={"center"}
    >
      <Box
        flexDirection={"column"}
        display={"flex"}
        gap={{ xs: 4, md: 4 }}
        width={"100%"}
        alignItems={"center"}
      >
        <Typography variant={isDesktop ? "h2" : "h4"}>
          Oppmerksomhetsledelse
        </Typography>
        <Box
          flexDirection={{ xs: "column", md: "row" }}
          flex={1}
          display={"flex"}
          gap={{ xs: 4, md: 10 }}
          justifyContent={"center"}
          alignItems={"center"}
          height={"fit-content"}
        >
          <Box
            alignSelf={"stretch"}
            justifyContent={"space-between"}
            flexDirection={"column"}
            display={"flex"}
            border={"solid 1px"}
            padding={{ xs: 1, md: 2 }}
            alignItems={"center"}
            width={"fit-content"}
            sx={{ cursor: "pointer" }}
            onClick={() =>
              (window.location.href = "https://potero.notion.site/")
            }
            role="link"
          >
            <Typography variant={isDesktop ? "h4" : "h6"}>Lær mer</Typography>
            <AnimatedBook link="https://potero.notion.site/" />
          </Box>

          <Box
            border={"solid 1px"}
            padding={{ xs: 1, md: 2 }}
            height={"100%"}
            alignSelf={"stretch"}
            justifyContent={"space-between"}
            flexDirection={"column"}
            display={"flex"}
            alignItems={"center"}
            width={"fit-content"}
            sx={{ cursor: "pointer" }}
            onClick={() =>
              (window.location.href =
                "https://bokklubb.hegnar.no/oppmerksomhetsledelse.html")
            }
            role="button"
          >
            <Typography variant={isDesktop ? "h4" : "h6"}>
              Finansavisen
            </Typography>
            <Typography variant={isDesktop ? "h4" : "h6"}>Bokklubb</Typography>
            <AnimatedBook link="https://bokklubb.hegnar.no/oppmerksomhetsledelse.html" />
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default App;
